import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { localeAwareFormat } from 'app/lib/date';
import { View } from 'react-native';
import type { ActivePlan } from './shared';

export const StopRecurrenceModal = ({
  activePlan,
  isOpen,
  isPending,
  onClose,
  onConfirm,
}: {
  activePlan: ActivePlan | undefined;
  isOpen: boolean;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useScopedTranslation();
  return (
    <Modal onClose={onClose} open={isOpen} transparent>
      <Modal.Card>
        <Modal.Title>{t('stopRecurrenceModal.title')}</Modal.Title>
        <Column>
          <Text textAlign="center">
            {t('stopRecurrenceModal.text', {
              date: localeAwareFormat(
                new Date(activePlan?.expiresAt ?? 0),
                t('dateFormat_MMMMdYYYY', { ns: 'common' }),
              ),
            })}
          </Text>
        </Column>
        <View>
          <Button loading={isPending} marginBottom="spacing.general.x4" onPress={onConfirm} variant="primary">
            {t('stopRecurrenceModal.ctaPositive')}
          </Button>
          <Button onPress={onClose} variant="secondary">
            {t('stopRecurrenceModal.ctaNegative')}
          </Button>
        </View>
      </Modal.Card>
    </Modal>
  );
};
